import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  EXPERIENCES_FETCH_FAILURE,
  EXPERIENCES_FETCH_SUCCESS,
  EXPERIENCE_COMPLETE_SUCCESS,
} from './types';

const experiences = createReducer(
  {},
  {
    [EXPERIENCES_FETCH_SUCCESS]: (draft, { payload }) => {
      const { experiences } = payload;
      for (const experience of experiences) {
        draft[experience.name] = experience;
      }
    },

    [EXPERIENCE_COMPLETE_SUCCESS]: (draft, { payload }) => {
      const { experience } = payload;
      draft[experience.name] = experience;
    },
  }
);

const isReady = createReducer(false, {
  [EXPERIENCES_FETCH_FAILURE]: () => false,
  [EXPERIENCES_FETCH_SUCCESS]: () => true,
});

export default combineReducers({
  experiences,
  isReady,
});
